export { opacityColor } from './opacityColor'
